module.exports = __webpack_public_path__ + "static/media/sign-in-text.c002ccf6.png";